import { CompanyIndustries, CompanyProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface ICompanyProps {
  id?: string
  industries?: CompanyIndustries[] | null
  name: string | null
  kana: string | null
  createdAt: string | null
  updatedAt: string | null
  properties: CompanyProperties | null
}

export interface ICompanyQueryProps {
  status?: string | null
  industries: string[] | null
}
export default class CompanyEntity {
  private _props: ICompanyProps

  constructor(props?: ICompanyProps | null) {
    this._props = EmptyCompanyPropsFactory(props)
  }

  get props(): ICompanyProps {
    return this._props
  }

  get clone(): ICompanyProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get industries(): CompanyIndustries[] | null | undefined {
    return this._props.industries
  }

  get name(): string | null {
    return this._props.name
  }

  get kana(): string | null {
    return this._props.kana
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): CompanyProperties | null | undefined {
    return this._props.properties
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

// 検索用のNGワード
export const ng = ['株式', '有限', '合同', '企業', '会社', '株式会社', '有限会社', '合同会社']

export const EmptyCompanyPropsFactory = (props?: Partial<ICompanyProps> | null): ICompanyProps => ({
  name: null,
  kana: null,
  createdAt: null,
  updatedAt: null,
  properties: null,
  ...props
})
